import http from "@/http/aisea/axios";

const resource = "/vessel";

export default {

  getVessel(id) {
    return http.get(`${resource}/${id}`);
  },

  search(payload) {
    return http.get(`${resource}/search/vessels`, {
      params: {
        items: payload,
      }
    });
  },

};
